export const SKU_SEPARATOR = '|.|'
export const EMAIL_PATTERN = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/)
export const NAMES_PATTERN = new RegExp(/^[a-zA-Z\' ]{2,}$/)
export const BRIGHTCOVE_POLICY_KEY = 'BCpkADawqM1H81ebc9FoqqnwX5rzl-BLQLAcKpDOXwDTcw7V6FUsB03KGzgb0qCaYskSgrGekKCUI-5n76cxViWROxbtZCq5QmHOs7hCuWvjQA_tocKMcs6AVLDbe7kVJ4BUfsgc_IkORUV5'
export const EMAIL_OR_USERNAME_PATTERN = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4}|[A-Z0-9]{10})$/;
export const AUTOCOMPLETE_MIN_CHARS = 3;
export const TRIAL_FREQUENCIES = {
    low:'low', high:'high', both:'both'
}